<template>
  <BlocksLandingContainer :styles="styles">
    <div :class="['flex container-fluid-lg items-start gap-8']">
      <div class="flex flex-col gap-4 w-full">
        <h2>
          {{ title }}
        </h2>

        <WebccMarkdown :content="text" />

        <div v-if="isSliderMode" class="flex flex-col gap-4 h-full">
          <div
            v-track:impression="{
              event: 'imageCarousel:displayed',
              args: [teasers],
            }"
            class="relative rounded-lg w-full"
          >
            <ImageSlider
              class="overflow-hidden h-full cursor-pointer"
              :images="images"
              cover-full
              dots="external"
              :image-height="'18rem'"
              container-classes="overflow-hidden rounded-lg"
            >
              <template #overlay="{ index }">
                <WebccLink
                  v-if="teasers[index].link.href"
                  :to="teasers[index].link.href"
                  anchor
                  :target="getLinkTarget(teasers[index].link)"
                  class="absolute w-full h-full"
                  @click="trackItemClick(index)"
                >
                  <div
                    class="absolute w-full bottom-0 h-[3.25rem] flex items-center justify-center bg-bgr text-black"
                  >
                    <span class="text-center text-bold underline text-l">{{
                      teasers[index].link.text
                    }}</span>
                  </div>
                </WebccLink>
              </template>
              <template #left-button="{ click }">
                <WebccButton
                  class="relative left-0 top-2/4 -translate-y-2/4 mx-4"
                  variant="grey"
                  icon="site/chevron-left-large"
                  round
                  @click="click"
                />
              </template>
              <template #right-button="{ click }">
                <WebccButton
                  class="relative right-0 top-2/4 -translate-y-2/4 mx-4"
                  variant="grey"
                  icon="site/chevron-right-large"
                  round
                  @click="click"
                />
              </template>
            </ImageSlider>
          </div>
        </div>
        <LandingImageCarousel
          v-else
          :teasers="teasers"
          :size="isLarge ? 'lg' : 'sm'"
        />
      </div>
    </div>
  </BlocksLandingContainer>
</template>

<script setup lang="ts">
const props = defineProps<{
  block: { content: LandingImageCarouselContent }
}>()

const screen = useScreen()
const tracking = useTracking()

const { size, styles, title, text, teasers } = toRefs(props.block.content)

const isLarge = computed(() => size.value === 'lg')
const isSliderMode = computed(() => isLarge.value && screen.isExtraSmall)
const images = computed(() =>
  teasers.value
    .map(({ image }) => image)
    .map(({ src, alt }, index) => ({
      id: index.toString(),
      src,
      alt,
      title: alt,
    })),
)
const trackItemClick = (index: number) => {
  tracking.handlers?.imageCarousel.view(teasers.value[index].link.text, index)
}
</script>
